module.exports = __webpack_public_path__ + "img/dbyloi-desktop-logo.c1a5225d.svg";